import React, { useState, useEffect } from "react";
import { getaboutus } from '../action/user';
import config from "../../lib/config";
import AOS from 'aos';

function About() {
    const [aboutus_image, setimage] = useState()
    const [aboutus_title, settitle] = useState()
    const [aboutus_content, setcontent] = useState()
    const getaboutData = async () => {
        var test = await getaboutus();
        // console.log("image",test);

        let image = config.API + "/images/user/" + test.userValue.image;
        setimage(image);

        settitle(test.userValue.title);
        setcontent(test.userValue.content);
    };

    useEffect(() => {
        //logout(history)
        getaboutData();
        window.scrollTo({ top: 550, left: 0, behavior: 'smooth' });
        AOS.init({
            // initialise with other settings
            duration: 2000
        });
    }, []);
    return (
        <div>
            <section className="inner-page-banners">
                <img className="images img-responsive" src={require('../../assests/images/payment-banner.gif')} />
                <div className="clearfix" />
            </section>


            {/* <section style={{ boxShadow: '0px 3px 23px 0px rgb(244, 246, 249)' }}>
            <div className="container about-us">
                <div className="text-center col-md-offset-4 col-md-3">
                    <div id="triangle_left" />
                    <p> எங்களை பற்றி</p>
                    <div id="triangle_right" />
                </div>
            </div>
        </section> */}

            <section className="headingzz">
                {/* <h3> About us </h3> */}
                <h2 class="col-md-12 col-12 pt-3 pb-3 text-center xs-pb0 font-great-vibes">
                    About us
                </h2>
            </section>
            <div class="row">
                <div class="col-md-12 col-12 pt-3 pb-3 text-center xs-pb0">
                    <img src={require("../../assests/images/yt-flower-center-img.svg").default} alt="YT center image" />
                </div>
            </div>
            {/*//about heading*/}
            {/*details*/}
            <section className="aboutdetails" data-aos="fade-up">
                <div className="container">
                    <div className="row">
                        <div className="text-center mb-4">
                            <h2 className="font-great-vibes">{aboutus_title} </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            {/* {aboutus_image ?
                                <img src={aboutus_image} />
                                : */}
                            <img src={require('../../assests/images/32930Banner.png')} />
                            {/* } */}
                        </div>
                        <div className="col-md-6 content">
                            <div dangerouslySetInnerHTML={{ __html: aboutus_content }} />

                        </div>
                    </div>
                </div>
            </section>
            {/*//details*/}
            {/*about details*/}
            <section className="aboutsection" data-aos="fade-zoom-in">
                <div className="container">
                    <div className="about">
                        <h2>Note</h2>
                        <p> We kindly request the grooms who have registered with us to inform us once their marriage is over. If you do not inform us of the completion of the marriage, the horoscope will remain intact in our matrimony. This wastes time and causes mental anguish to those looking for a groom. Therefore, if you who have registered inform us of the completion of the marriage, we will delete the horoscope.</p>
                    </div>
                </div>
            </section>
        </div>

    )
}
export default About;
